import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	displayFormatHeader: {
		id: 'servicedesk-sla-settings.common.sla-display-format.sla-display-format-title.display-format-header',
		defaultMessage: 'SLA format display',
		description: 'header for sla display formats',
	},
	displayFormatHeaderExplaination: {
		id: 'servicedesk-sla-settings.common.sla-display-format.sla-display-format-title.display-format-header-explaination',
		defaultMessage:
			'Choose a format for hover states of this SLA to display. The format is effective on both issue and queue view.',
		description: 'header for sla display formats',
	},
});
